<template lang="pug">
    tr

        // Date created
        td {{ item.createdAt | formattedDate }}

        // Business Name
        td {{ item.name }}

        // Contact Name
        td(v-if="item.owner && item.owner.fullName") {{ item.owner.fullName }}
        td(v-else)

        // Program date (Start/End)
        td(v-if="item.program && item.program.startedAt") {{ item.program.startedAt | formattedDate }} - {{ item.program.endedAt | formattedDate }}
        td(v-else)

        // Status
        td
            status-component(v-if="item.isActive") {{ $t('business.list.status.active')}}
            status-component.warningColor(v-else ) {{ $t('business.list.status.inactive')}}

        // Count users (Current/Max)
        td {{ item.countUsers ? item.countUsers : '0' }} / {{ item.maxUsers }}

        // Actions
        td.text-xs-right(class="justify-center px-0 actions")


            // Goals view
            button-component.userList(:action="goalsView" color="primary" icon="track_changes")

            // Users list button
            button-component.goals(:action="usersView" color="primary" icon="people")

            // Edit business button
            button-component.edit(:action="edit" color="primary" icon="edit")

            // Delete business button
            button-component.delete(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import Status from '~components/Status';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone'; 
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status
        },
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            ...mapActions('businesses', ['deleteAccount']),
            /**
             * Goals by business
             */
            goalsView() {
                this.$router.push({
                    name: 'dashboard.businesses.goals',
                    params: { id: this.item.id }
                });
            },
            /**
             * Users by business
             */
            usersView() {
                this.$router.push({
                    name: 'dashboard.users.by.business',
                    params: { id: this.item.id }
                });
            },
            /**
             * Edit business
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.businesses.edit',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete business.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount({ id: this.item.id });

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            },

            /**
             * Get title for business program
             * @param item
             * @returns {TranslateResult|VueI18n.TranslateResult|string|{custom: string, challenge: string}|{custom: string, challenge: string}}
             */
            getProgramTitle(item) {
                if (item.programTitle) {
                    return item.programTitle;
                }

                if (item.isCustomProgram) {
                    return this.$t('business.list.programTitle.custom');
                }

                if (item.isChallenge) {
                    return this.$t('business.list.programTitle.challenge');
                }

                return '';
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .role
        text-transform: capitalize
</style>
